import { baseApi } from './baseApi';
import type { Question } from '../types';

const bookmarksApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getUserBookmarks: builder.query<Question[], void>({
      query: () => '/questions/bookmarks/',
      providesTags: (_result, _error) => {
        const userId = localStorage.getItem('userId');
        return [{ type: 'Bookmarks', id: userId || undefined }, 'Questions'];
      },
      keepUnusedDataFor: 10 * 60,
    }),

    bookMarkQuestion: builder.mutation<Question, { questionId: string; userId: string }>({
      query: ({ questionId }) => ({
        url: `/questions/bookmark/${questionId}`,
        method: 'POST',
      }),
      invalidatesTags: (_result, _error, { userId }) => [
        { type: 'UserQuestions', id: userId },
        { type: 'Bookmarks', id: userId },
        'Questions',
      ],
    }),
  }),
});

export const {
  useGetUserBookmarksQuery,
  useBookMarkQuestionMutation,
} = bookmarksApi;
